import { useSelector } from "react-redux";
import { getLocalization } from "../../redux/localization";

const Get3DFailMessage = ({ status }: { status: string }) => {
  const t = useSelector(getLocalization);
  const getMessage = () => {
    switch (status) {
      case "0":
        return t.getString("mdstatus0");
      case "2":
        return t.getString("mdstatus2");
      case "3":
        return t.getString("mdstatus3");
      case "4":
        return t.getString("mdstatus4");
      case "5":
        return t.getString("mdstatus5");
      case "6":
        return t.getString("mdstatus6");
      case "7":
        return t.getString("mdstatus7");
      case "8":
        return t.getString("mdstatus8");
      default:
        return status;
    }
  };
  return <>{getMessage()}</>;
};
export default Get3DFailMessage;
